import React from "react";

const STYLES = {
  draft: { bg: "#f3f4f6", fg: "#6b7280", label: "Draft" },
  submitted: { bg: "#fef3c7", fg: "#92400e", label: "Submitted" },
  approved: { bg: "#dcfce7", fg: "#166534", label: "Approved" },
  rejected: { bg: "#fee2e2", fg: "#991b1b", label: "Sent back" },
};

export default function StatusChip({ status, note }) {
  const s = STYLES[status] || STYLES.draft;
  return (
    <span title={note || ""} style={{
      background: s.bg, color: s.fg, borderRadius: 999, padding: "2px 10px",
      fontSize: 12, fontWeight: 600, whiteSpace: "nowrap",
    }}>
      {s.label}
    </span>
  );
}
